<template>
<div id="mine">
    <!--顶部导航栏-->
    <nav-bar></nav-bar>
    <div class="mine-center" style="background: #f6f8f7">
        <div class="mine-center-header">
            <van-image  :src="userInfo.icon" alt="" width="70px" height="70px" round/>
        </div>
        <div class="min-center-name" style="color: black">
                {{ userInfo.nickname }}
        </div>
        <div class="min-center-right">
            <van-icon name="arrow" size="30" @click="userInfoMessage()"/>
<!--            <img :src="require('@/assets/image/icon/right_arrow.png')" alt="" @click="userInfoMessage()">-->
        </div>
    </div>
<!--    <div class="mine-attention">-->
<!--        <van-row>-->
<!--            <van-col span="8">-->
<!--                <span class="mine-attention-name">积分</span><br>-->
<!--                <span class="mine-attention-num">100</span>-->
<!--            </van-col>-->
<!--            <van-col span="8">-->
<!--                <span class="mine-attention-name">优惠券</span><br>-->
<!--                <span class="mine-attention-num">100</span>-->
<!--            </van-col>-->
<!--            <van-col span="8" @click="toAttentionList">-->
<!--                <span class="mine-attention-name">关注</span><br>-->
<!--                <span class="mine-attention-num">100</span>-->
<!--            </van-col>-->
<!--        </van-row>-->
<!--    </div>-->

    <div style="width: 95%; height: 40px; background: #ffffff; margin: auto; border-top-right-radius: 10px; border-top-left-radius: 10px;">
        <div style="width: 100%; height: 13px;"></div>
        <div class="mine-order-item" style="margin-left: 20px; " @click="myOrder(0)">
            <span style=" font-weight: 700; font-size: 15px;">{{langText.myOrder}}</span>
            <div style="width: 7px; height: 15px; background: #ff6034; position: relative; left: -10px;  top: -16px; " ></div>
        </div>
    </div>

    <div style="width: 95%; height: 4px; margin: auto; background: white">
      <div style="width: 90%; height: 2px; margin: auto; background: #f6f8f7"> </div>
    </div>

    <div class="mine-order" style="width: 95%; margin: auto; ">
        <div class="mine-order-item" @click="myOrder(1)">
            <img style="width: 40px; height: 40px;" :src="require('@/assets/image/icon/wode_icon_daizhifu@3x.png')" >
            <span>{{langText.obligation}}</span>
        </div>
        <div class="mine-order-item" @click="myOrder(2)">
            <img style="width: 40px; height: 40px;" :src="require('@/assets/image/icon/wode_icon_daifahuo@2x.png')" >
            <span>{{langText.waitingForDelivery}}</span>
        </div>
        <div class="mine-order-item" @click="myOrder(3)">
            <img style="width: 40px; height: 40px;" :src="require('@/assets/image/icon/wode_icon_daishouhuo@2x.png')" >
            <span>{{langText.shipped}}</span>
        </div>
        <div class="mine-order-item" @click="afterSalesService">
            <img style="width: 40px; height: 40px;" :src="require('@/assets/image/icon/icon_yiwancheng@2x.png')" >
            <span>{{langText.afterSales}}</span>
        </div>
    </div>

    <div style="width: 95%; height: 10px; margin: auto; background: white; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;">
    </div>



    <br/>
<!--        <div class="mine-col">-->
<!--        <div class="mine-col-item" @click="toMyCol(0)">-->
<!--            <img :src="require('@/assets/image/icon/mine_col.png')" alt="">-->
<!--            <span>我的收藏</span>-->
<!--        </div>-->
<!--        <div class="mine-col-item" @click="toMyCol(0)">-->
<!--            <div>100</div>-->
<!--            <span>商品</span>-->
<!--        </div>-->
<!--        <div class="mine-col-item" @click="toMyCol(1)">-->
<!--            <div>100</div>-->
<!--            <span>专题</span>-->
<!--        </div>-->
<!--        <div class="mine-col-item" @click="toMyCol(2)">-->
<!--            <div>100</div>-->
<!--            <span>话题</span>-->
<!--        </div>-->
<!--    </div>-->

<!--    <div class="mine-footprint">-->
<!--        <van-icon name="browsing-history-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
<!--        <span class="mine-footprint-name">我的足迹</span>-->
<!--        <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>-->
<!--        <span class="mine-footprint-num">10</span>-->
<!--    </div>-->

<!--    <div class="mine-comment">-->
<!--        <van-icon name="comment-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
<!--        <span class="mine-comment-name">我的评价</span>-->
<!--        <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>-->
<!--        <span class="mine-comment-num">10</span>-->
<!--    </div>-->

    <div style="width: 95%; height: 30px; background: #ffffff; margin: auto; border-top-left-radius: 10px; border-top-right-radius: 10px">
    <router-link to="/mine/addressList">
        <div class="mine-address-manage" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
            <van-icon name="browsing-history-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>
            <span class="address-manage-name">{{langText.addressManagement}}</span>
            <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>
        </div>
    </router-link>

        <router-link to="/mine/accounts">
            <div class="mine-address-manage">
<!--                <van-icon name="browsing-history-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
                <van-icon name="contact" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>
                <span class="address-manage-name">{{langText.accountsSndSecurity}}</span>
                <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>
            </div>
        </router-link>

       <!--设置语言-->
        <router-link to="/mine/accounts/langSet">
            <div class="mine-address-manage">
                <van-icon name="other-pay" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>
                  <span class="address-manage-name">{{langText.langSet}}</span>
                <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>
            </div>
        </router-link>
        <!--end-->

        <!--退出按钮-->
        <div class="mine-address-manage" @click="loginOut" style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
            <van-icon name="close" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>
            <span class="address-manage-name">{{langText.exitAccount}}</span>
            <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>
        </div>

    </div>



<!--    <div class="mine-members">-->
<!--        <van-icon name="browsing-history-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
<!--        <span class="mine-members-name">我的会员</span>-->
<!--        <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>-->
<!--        <span class="mine-members-num">黄金会员</span>-->
<!--    </div>-->

<!--    <div class="service-center">-->
<!--        <van-icon name="comment-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
<!--        <span class="service-center-name">服务中心</span>-->
<!--        <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>-->
<!--    </div>-->

<!--    <div class="mine-system-settings">-->
<!--        <van-icon name="browsing-history-o" size="27" style="margin-top: 10px;float: left; padding-left: 10px"/>-->
<!--        <span class="system-settings-name">系统设置</span>-->
<!--        <van-icon name="arrow" size="27" style="float: right; margin-top: 10px;"/>-->
<!--    </div>-->
</div>
</template>

<script>

    import NavBarIndexContent from "@/components/content/navbar/NavBarIndexContent";
    import { Col, Row, Icon, Image, Divider, Dialog} from 'vant'
    import {getUserInfo} from "../../network/index";
    import { langPackage } from "@/config/lang/mineLang";
    import { selectLang } from "@/config/setLanguage"

export default {
  name: "Mine",
    components: {
      NavBar: NavBarIndexContent,
        [Col.name]: Col,
        [Row.name]: Row,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Divider.name]: Divider,
        [Dialog.name]:Dialog
    },
    data(){
      return{
          userInfo: {
              username: '',
              icon: '',
              id:''
          },
          dialogVisible:false,
          commonText:"",
          langText:{}
      }
    },
    methods: {
        myOrder(index){
            this.$router.push({ path: '/order/personalOrders', query: {active: index}})
        },
        afterSalesService() {
            this.$router.push({ path: 'order/afterSalesServiceList'})
        },
        toAttentionList() {
            this.$router.push({ path: '/mine/attentionBrands'})
        },
        toMyCol(type){
            this.$router.push({ path: '/mine/myCollection', query: { type: type } })
        },

        loginOut(){ //登出按钮
            Dialog.confirm({
                title: this.langText.title,
                message: this.langText.message,
                confirmButtonText: this.commonText.confirm,
                cancelButtonText: this.commonText.cancel,
            }).then(() => {
                    this.$store.dispatch('FedLogOut', this.loginForm).then(() => {
                        this.$router.push({path: '/'})
                    }).catch(err => {
                        Toast(this.commonText.fail)
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        userInfoMessage(){
            //跳转到会员的详细页面
            this.$router.push({path: '/mine/userInfo',query:{id:this.userInfo.id}});
        }
    },
    created() {
        //获取语言包
        selectLang(langPackage).then(langtxt =>{
            this.langText = langtxt.langtxt;
            this.commonText = langtxt.common;
        });

      getUserInfo().then(res => {
          if(res.code == 200){
              if (res.data.icon.substring(0,5) == "https"){
                  this.userInfo = {
                      'nickname': res.data.nickname,
                      'icon': res.data.icon,
                      'id':res.data.id
                  }
              }else {
                  this.userInfo = {
                      'nickname': res.data.nickname,
                      'icon': "https://www.agougoubuy.cn/agg-portal/ap/sso/getUserIcon?type=user&icon="+res.data.icon,
                      'id':res.data.id
                  }
              }



          }

      })

    }
}
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #mine{
        background: #f6f8f7;
        /*height: 800px;*/
        width: 100%;
    }

    .mine-center {
        background-color: #636363;
        height: 171px;
        margin-top: 46px;
    }

    .mine-center-header {
        padding-top: 40px;
        margin-left: 41%;
        float: left;
    }
    .min-center-name {
        width: 100%;
        height: 20px;
        position: absolute;
        top: 160px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        letter-spacing:2px;
    }
    .min-center-right {
        float: right;
        padding-top: 73px;
        margin-right: 20px;
    }
    .mine-attention {
        height: 61px;
        background-color: #f9f9f9;
    }
    .mine-attention .van-row {
        text-align: center;
        padding-top: 12px;
    }
    .mine-attention .mine-attention-name {
        font-size: 13px;
        color: #666666;
    }

    .mine-attention .mine-attention-num {
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
        font-size: 16px;
        color: #2AB795;
        font-weight: 700;
    }

    .mine-order {
        /*margin-top: 15px;*/
        height: 74px;
        background-color: #ffffff;
        display: flex;
    }

    .mine-order .mine-order-item {
        flex: 1;
        text-align: center;
        padding-top: 11px;
    }
    .mine-order-item span {
        font-size: 13px;
        color: #666666;
        display: block;
    }

    .mine-col {
        margin-top: 1px;
        height: 77px;
        background-color: #f9f9f9;
        display: flex;
    }

    .mine-col-item {
        flex: 1;
        text-align: center;
        padding-top: 11px;
    }

    .mine-col-item span {
        font-size: 13px;
        color: #666666;
        display: block;
    }

    .mine-col-item div {
        height: 30px;
        text-align: center;
        line-height: 30px;
    }

    .mine-footprint {
        margin-top: 15px;
        height: 49px;
        background-color: #f9f9f9;
        color: #333333;
    }

    .mine-footprint-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }

    .mine-footprint-num {
        float:right;
        line-height: 49px;
        padding-right: 10px;
        color: #666666;
    }

    .mine-comment {
        margin-top: 1px;
        height: 49px;
        background-color: #f9f9f9;
        color: #333333;
    }

    .mine-comment-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }

    .mine-comment-num {
        float:right;
        line-height: 49px;
        padding-right: 10px;
        color: #666666;
    }

    .mine-address-manage {
        margin-top: 1px;
        height: 49px;
        background-color: #ffffff;
        color: #333333;
        /*border-radius: px;*/
    }

    .address-manage-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }

    .address-manage-num {
        float:right;
        line-height: 49px;
        padding-right: 10px;
        color: #666666;
    }

    .mine-members {
        margin-top: 10px;
        height: 49px;
        background-color: #f9f9f9;
        color: #333333;
    }

    .mine-members-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }

    .mine-members-num {
        float:right;
        line-height: 49px;
        padding-right: 10px;
        color: #666666;
        font-size: 13px ;
    }

    .service-center {
        margin-top: 1px;
        height: 49px;
        background-color: #f9f9f9;
        color: #333333;
    }

    .service-center-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }


    .mine-system-settings {
        margin-top: 1px;
        height: 49px;
        background-color: #f9f9f9;
        color: #333333;
    }

    .system-settings-name {
        float: left;
        line-height: 49px;
        padding-left: 5px;
    }

    .mine-bottom {
        height: 50px;
    }
    a:link {
        color: #333333;
        text-decoration: none;
    }
    a:visited {
        color: #333333;
        text-decoration: none;
    }

</style>
